import { formatGetHeaders } from '@configurations/api-configuration';
import { UnitRatesGateway } from '@scenario/gateways/unit-rates.gateway';
import { environment } from '../../../../../environments/environment';
import { UnitRate } from '@scenario/models/unit-rate.model';
import { UnitRatesMapper } from './unit-rates.mapper';

export class ApiUnitRatesGateway implements UnitRatesGateway {
  private readonly unitRatesApi = `${environment.backend_url}/api/v1/unit`;
  private readonly mapper = new UnitRatesMapper();

  async retrieveAll(): Promise<UnitRate[]> {
    try {
      const response = await fetch(`${this.unitRatesApi}`, await formatGetHeaders());
      const data = await response.json();
      return this.mapper.mapArrayToModelDomain(data);
    } catch {
      throw new Error('Error retrieving unit rates');
    }
  }
}
